import { useTranslation } from 'react-i18next'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import AddNewButton from '../AddNewButton'
import FullPageTemplate from '../../../../components/templates/FullPageTemplate'
import MMainMenu from '../../../menu/mainMenu/M.MainMenu'
import PageContent from './PageContent'
import { PermissionChecker } from '../../../session'
import Separator from '../../../../components/helpers/Separator'
import PageHeader from './PageHeader'
import MPageHeader from '../../../../components/presentation/M.PageHeader'

const MServiceOrdersListPage = () => {
  const { t } = useTranslation(['common', 'listUsers'])

  return (
    <FullPageTemplate>
      <PermissionChecker permission="listServiceOrder">
        <FilterHandler tempStorageNamespace="users" initialState={{}}>
          <MPageHeader title={t('listUsers:title')} />
          <PageHeader />
          <PageContent />
        </FilterHandler>
        <Separator />
        <MMainMenu active="users" />
        <AddNewButton />
      </PermissionChecker>
    </FullPageTemplate>
  )
}

export default MServiceOrdersListPage
